import { filter, get, keyBy, pick } from 'lodash/fp';
import { createSelector } from 'reselect';
import { number, ord } from 'fp-ts';
import { createAction, createReducer } from '@mews/framework';
import { getStringProp } from '@mews/fp';
import { ApplicationState } from '@mews-commander/types';
import { RateGroup } from '@mews-commander/data-access';
import { sortByName, createOptionsSelector } from '@mews-commander/utils';
import moduleSelector from '../selector';
import { RATE_GROUPS_FETCH_SUCCEEDED } from './actionTypes';
import { Entities } from './utils';

export const NAME = 'rateGroups';
export const rateGroupOrd = ord.contramap((rate: RateGroup) => rate.ordering)(number.Ord);

export const setRateGroups = (rateGroups: $TSFixMe, scope: $TSFixMe) =>
    createAction(RATE_GROUPS_FETCH_SUCCEEDED, { rateGroups, serviceId: scope });

export const rateGroupsReducer = createReducer(
    {},
    {
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [RATE_GROUPS_FETCH_SUCCEEDED]: (state, { rateGroups }: $TSFixMe) => ({
            ...state,
            ...keyBy('id', rateGroups),
        }),
    }
);

export const getRateGroups = createSelector<ApplicationState, Record<string, {}>, Entities<RateGroup>>(
    moduleSelector,
    (module) => module[NAME] || {}
);
export const getRateGroup = createSelector(
    getRateGroups,
    getStringProp('rateGroupId'),
    (rateGroups, id) => rateGroups[id] || {}
);

export const getRateGroupName = createSelector(getRateGroup, get('name'));
export const getRateGroupNameVariants = createSelector(getRateGroup, pick(['name', 'shortName']));

export const getServiceRateGroups = createSelector(getStringProp('serviceId'), getRateGroups, (serviceId, rateGroups) =>
    filter({ serviceId })(rateGroups)
);

export const getServiceRateGroupOptions = createOptionsSelector(getServiceRateGroups, { sortFunction: sortByName });
